import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { Import, ImportCommitBody } from "@guestbook/shared";
import { apiFetch, type ApiClientError } from "@/shared/lib/api";

/**
 * Commits a client-parsed import (POST /imports). On success the contacts list
 * and households caches are invalidated so the new contacts show up.
 */
export function useImportContacts() {
  const qc = useQueryClient();
  return useMutation<Import, ApiClientError, ImportCommitBody>({
    mutationFn: (body) =>
      apiFetch<Import>("/imports", {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["contacts", "list"] });
      qc.invalidateQueries({ queryKey: ["households"] });
    },
  });
}
